module.exports = __webpack_public_path__ + "media/images/area/popular/shibuya-a56858afa711532e6752ae96d3edb885.jpg";